import { ComponentType } from 'react';
import { Typography } from '@mui/material';
import { LocationsEditForm, LocationsEditFormProps } from '../locations-edit-form';
import { useTranslation } from 'react-i18next';
import { BaseDialog } from '../../dialogs';

interface LocationsEditDialogProps extends LocationsEditFormProps {
  title?: string;
  popDialog?: any;
}

export const LocationsEditDialog: ComponentType<LocationsEditDialogProps> = ({
  title: dialogTitle,
  id,
  popDialog,
  onSubmit,
  ...props
}) => {
  const { t } = useTranslation();
  const defaultTitle = !!id
    ? t('locations.edit', 'Редактиовать офис')
    : t('locations.add', 'Добавить офис');
  const title = dialogTitle ? dialogTitle : defaultTitle;

  return (
    <BaseDialog {...{ ...props, popDialog }}>
      {title && (
        <Typography variant="h2" component="h6" mb={2}>
          {title}
        </Typography>
      )}
      <LocationsEditForm id={id} onSubmit={onSubmit} onCancel={popDialog} />
    </BaseDialog>
  );
};
